
import React from "react";
import { Schemes } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import { Elements } from "../../../shared/Elements";
import { Siren } from "../../../shared/ConfirmDialog";
import { Button, Checkbox, Form } from "@rivtn/noseur";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, IMember, IProfileWebsite, MemberService, SanitizedResponse } from "../../../../services";

export interface AchievementsProps {
    profile: IMember;
}

function Achievements(_: AchievementsProps) {

    const memberService = MemberService.getInstance();
    const labels = i18nManager.Labels.account.profile_website.achievements;
    const [profileWebsite, setProfileWebsite] = React.useState<IProfileWebsite>();

    React.useEffect(() => {
        memberService.getProfileWebsite().then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
            setProfileWebsite(sanitized);
        }).catch(BaseService.reportError);
    }, []);

    return (<div className="account-setting">
        <div className="header">
            <span className="title">{i18nManager.Labels.account.profile_website.title} - {labels.title}</span>
        </div>
        {!profileWebsite
            ? (<div style={{ margin: "90px 110px" }}>
                <img alt={"loading"} src={LoadingGif} style={{ width: 80, margin: "auto" }} />
            </div>)
            : (<Form scheme={Schemes.OMNEHOST} className="profile-settings">
                <Checkbox label={labels.enable_ad} defaultChecked={profileWebsite?.achievement_settings?.enable_rivtn_ad} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, enable_rivtn_ad: e.checked } })
                }} />
                <hr />
                <span style={{ fontWeight: "bold", margin: "10px 0px" }}>{labels.leaderboard_ranking}</span>
                <Checkbox label={labels.show_trails} defaultChecked={profileWebsite?.achievement_settings?.show_leaderboard_trails} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_leaderboard_trails: e.checked } })
                }} />
                <Checkbox label={labels.show_graphs} defaultChecked={profileWebsite?.achievement_settings?.show_leaderboard_graphs} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_leaderboard_graphs: e.checked } })
                }} />
                <span style={{ fontWeight: "bold", margin: "10px 0px", marginTop: 25 }}>{labels.trophies}</span>
                <Checkbox label={labels.show_trails} defaultChecked={profileWebsite?.achievement_settings?.show_trophies_trails} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_trophies_trails: e.checked } })
                }} />
                <Checkbox label={labels.show_graphs} defaultChecked={profileWebsite?.achievement_settings?.show_trophies_graphs} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_trophies_graphs: e.checked } })
                }} />
                <span style={{ fontWeight: "bold", margin: "10px 0px", marginTop: 25 }}>{labels.winnings}</span>
                <Checkbox label={labels.show_trails} defaultChecked={profileWebsite?.achievement_settings?.show_winnings_trails} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_winnings_trails: e.checked } })
                }} />
                <Checkbox label={labels.show_graphs} defaultChecked={profileWebsite?.achievement_settings?.show_winnings_graphs} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_winnings_graphs: e.checked } })
                }} />
                <span style={{ fontWeight: "bold", margin: "10px 0px", marginTop: 25 }}>{labels.team_achievements}</span>
                <Checkbox label={labels.show_team_winning_trails} defaultChecked={profileWebsite?.achievement_settings?.show_team_winnings_trails} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_team_winnings_trails: e.checked } })
                }} />
                <Checkbox label={labels.show_team_winning_graphs} defaultChecked={profileWebsite?.achievement_settings?.show_team_winnings_graphs} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_team_winnings_graphs: e.checked } })
                }} />
                <Checkbox label={labels.show_team_trophies_trails} defaultChecked={profileWebsite?.achievement_settings?.show_team_trophies_trails} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_team_trophies_trails: e.checked } })
                }} />
                <Checkbox label={labels.show_team_trophies_graphs} defaultChecked={profileWebsite?.achievement_settings?.show_team_trophies_graphs} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, achievement_settings: { ...profileWebsite.achievement_settings, show_team_trophies_graphs: e.checked } })
                }} />
                <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.save_changes} loadingProps={Elements.BUTTON_LOADING_PROPS}
                    style={{ marginTop: 20 }} onClick={(e) => {
                        e.manageRef?.setLoadingState(true);
                        updateProfileWebsite(() => e.manageRef?.setLoadingState(false));
                    }} />
            </Form>)}
    </div>);

    function updateProfileWebsite(onDone?: () => void) {
        memberService.updateProfileWebsite(profileWebsite!).then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
            setProfileWebsite(sanitized);
            Siren.alert(i18nManager.Labels.account.profile_website.update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Achievements;
